<template>
    <div class="modal-content modal--happy">
        <div class="modal-header border-0 text-ceter">
            <modal-close />
            <div class="modal-title">
                <h2 class="h3 px-2 pt-4 pb-1">Przetwarzanie danych</h2>
            </div>
        </div>
        <div class="modal-body p-4 text-primary">
            <div class="tr-data mb-4 is-column">
                <div v-for="(section, sectionIdx) in dataProcessingFiles" :key="sectionIdx">
                    <div v-if="section.description">
                        {{ section.description }}
                    </div>
                    <div class="mt-2 " v-for="(file,fileIdx) in section.files" :key="fileIdx">
                        <a :href="`/regulations/${file.path}`" target="_blank">
                            {{ file.name? file.name:file.path }}
                        </a>
                    </div>
                </div>

            </div>

            <div class="text-center">
                <button
                    class="btn btn-outline-secondary"
                    @click="closeModal"
                    data-dismiss="modal"
                >Zamknij</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        dataProcessingFiles() {
            return this.$store.getters.getUserDataProcessingSections
        }
    },
    methods: {
        closeModal() {
            this.$store.dispatch('toggleModal', false)
        }
    }
}
</script>